<script setup lang="ts">
import type { LeafletMarkerRef } from '@/js/vue/composable/leaflet-map.ts';
import type { Map } from 'leaflet';
import { useLeafletMap } from '@/js/vue/composable/leaflet-map.ts';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import 'leaflet/dist/leaflet.css';

const { center } = defineProps<{
  center: number[]
}>();

const mapInstance = defineModel<Map>('map');
const marker = defineModel<LeafletMarkerRef>('marker');
const { createMap, createMarker } = useLeafletMap();
const mapContainerRef = ref<HTMLDivElement>();

onMounted(() => {
  if (!mapContainerRef.value) {
    return;
  }
  const map = createMap(mapContainerRef.value, { center, zoom: 10 });
  mapInstance.value = map;
  marker.value = createMarker(map, center);
});

onBeforeUnmount(() => {
  marker.value?.destroy();
  mapInstance.value?.remove();
  marker.value = undefined;
  mapInstance.value = undefined;
});
</script>

<template>
  <div ref="mapContainerRef" class="leaflet-map" />
</template>

<style scoped lang="scss">
.leaflet-map {
  width: 100%;
  height: 600px;
}
</style>
